module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "unu"
    }
  }), _vm._v("Unusual Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg22lev1"
    }
  }), _vm._v("I’ve made a point to only use ingredients that are readily available, and in any instance where I have not "), _c('a', {
    attrs: {
      "href": "#/xhtml/043part03chapter05#part3ch5"
    }
  }, [_vm._v("(for example, in the Zucchini + Nigella Fritters on page 107)")]), _vm._v(", I have explained why I have included something obscure and have also suggested substitutions. The following not-totally-obscure, but also not-totally-obvious ingredients pop up in more than one place throughout the book. While I use them frequently, I understand that they might not be as regularly featured in your kitchen. Here are some thoughts on them.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg22para2"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Buttermilk")])]), _vm._v(", readily available in the dairy aisle, is the liquid that’s leftover after cream has been churned into butter. It’s thick and tangy and remarkably good for you (it’s much lower in fat than it appears) and is also wonderful for baking and marinating since its acidity adds flavor and tenderizes everything from cakes to fried chicken. If buying a carton for just a small amount seems off- putting, check out the index to see all the recipes that use it, use extra to marinate a chicken before roasting, or simply substitute an equal amount of whole milk with a little fresh lemon juice or white vinegar stirred into it and let the milk mixture sit for about 10 minutes before using. Buttermilk has the added advantage of keeping, refrigerated, for up to 3 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg22lev3"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Crème fraîche")])]), _vm._v(", often found either in the dairy aisle near the sour cream or in the cheese department, is essentially French sour cream. It’s not quite as sour as American sour cream and it’s got a higher fat content, which makes it wonderfully decadent. I use it in so many things because it’s good cold "), _c('a', {
    attrs: {
      "href": "#/xhtml/093part07chapter06#part7ch6"
    }
  }, [_vm._v("(try a dollop on a slice of cake, such as the Afternoon Cake on page 229)")]), _vm._v(" and also works really well in cooked applications, such as a substitution for béchamel in both lasagana "), _c('a', {
    attrs: {
      "href": "#/xhtml/061part04chapter09#part4ch9"
    }
  }, [_vm._v("(see page 145)")]), _vm._v(" and chicken pot pie "), _c('a', {
    attrs: {
      "href": "#/xhtml/076part05chapter14#part5ch14"
    }
  }, [_vm._v("(see page 184)")]), _vm._v(". If you can’t find it, simply substitute an equal amount of regular sour cream. Feel free to whisk in a little heavy cream or plain cream cheese to up the fat content.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg22lev4"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Fish sauce")])]), _vm._v(", which I like to think of as Southeast Asian equivalent of Worcestershire sauce (whose main ingredient is, believe it or not, anchovies), is a dark brown liquid made from fermented anchovies. I know that sounds so terrible, but it’s truly one of the world’s most incredible condiments, totally full of funk and a deep, salty flavor. I use it in many recipes and find it to be so valuable. It’s readily available in most supermarkets these days, almost always next to the soy sauce. It’s also available in Asian grocery stores and online from "), _c('a', {
    attrs: {
      "href": "http://redboatfishsauce.com",
      "target": "_blank"
    }
  }, [_vm._v("redboatfishsauce.com")]), _vm._v(". Nothing really mimics its flavor, but you can substitute half rice vinegar and half soy sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg22lev5"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Gochugaru")])]), _vm._v(" (Korean red chile flakes) and "), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Aleppo pepper")])]), _vm._v(" (Middle Eastern red chile flakes) are two of the dried chiles I adore and use frequently. You can substitute regular red pepper flakes for either (like the ones that are on the counter at pizza joints), but use a bit less as both gochugaru and Aleppo "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("pepper are not quite as spicy as standard red pepper flakes. Both are increasingly available in speciality food stores and are also readily available online through "), _c('a', {
    attrs: {
      "href": "http://kalustyans.com",
      "target": "_blank"
    }
  }, [_vm._v("kalustyans.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg23lev1"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Gochujang")])]), _vm._v(", a Korean hot-pepper paste made primarily out of gochugaru (Korean red chile flakes), is one of my all-time favorite condiments. You can use an equal amount of any chile paste in its place, such as Sriracha. To find gochujang, check out your local Asian market or go online to "), _c('a', {
    attrs: {
      "href": "http://hmart.com",
      "target": "_blank"
    }
  }, [_vm._v("hmart.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg23lev2"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Kimchi")])]), _vm._v(", basically Korean sauerkraut, is an umbrella term that refers to any fermented vegetable, but the most common type, and the one I refer to any time I call for kimchi, is napa cabbage kimchi with plenty of Korean red chile pepper. These days, kimchi is easier than ever to find and you can often locate it in the refrigerated section of the produce department in plenty of grocery stores (near the refrigerated salad dressings) and also near the refrigerated pickles. It is also sometimes, sort of oddly, in the dairy section. Anywhere there’s a space in the refrigerator, I guess? Anyway, you can also find kimchi in most Asian grocery stores and also online at "), _c('a', {
    attrs: {
      "href": "http://hmart.com",
      "target": "_blank"
    }
  }, [_vm._v("hmart.com")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://milkimchi.com",
      "target": "_blank"
    }
  }, [_vm._v("milkimchi.com")]), _vm._v(", and Mama O’s ("), _c('a', {
    attrs: {
      "href": "http://kimchirules.com",
      "target": "_blank"
    }
  }, [_vm._v("kimchirules.com")]), _vm._v("). I am particularly partial to Mama O’s Super Spicy variety. They also carry a great vegan version (most kimchi has shrimp, anchovy, and/or other seafood in it). The liquid that the kimchi comes packed in is just as valuable as the kimchi itself, so be sure not to pour it down the drain. See the recipe on "), _c('a', {
    attrs: {
      "href": "#/xhtml/012part01chapter01#part1ch1"
    }
  }, [_vm._v("page 26")]), _vm._v(" and the Spin-Off on "), _c('a', {
    attrs: {
      "href": "#/xhtml/012part01chapter01#pg27lev1"
    }
  }, [_vm._v("page 27")]), _vm._v(" for more about ways to use the juice.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg23lev3"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Pimentón")])]), _vm._v(", Spanish smoked paprika, is the most crucial spice in Spanish cooking. It basically tastes like the most amazing peppery, smoky, slightly sweet barbeque sauce in powdered form. It’s available in both hot and sweet forms, and my preference is for hot since I like food on the spicy side—but feel free to use whichever you prefer (or have on hand). Pimentón has become so popular in the past decade or so that it’s now much easier to find than it used to be. Check the spice aisle in your local grocery store. If you can’t find it there, go online to "), _c('a', {
    attrs: {
      "href": "http://kalustyans.com",
      "target": "_blank"
    }
  }, [_vm._v("kalustyans.com")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "http://latienda.com",
      "target": "_blank"
    }
  }, [_vm._v("latienda.com")]), _vm._v(". You can also substitute regular paprika in its place.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg23lev4"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Preserved lemons")])]), _vm._v(" are whole lemons that have been preserved in salt. Very popular in North African cooking, preserved lemons are packed in jars and look almost like candied fruit floating in brine. They taste like a lemon that bumped into a pickle that then collided with something deeper and richer—maybe an intense olive or something. You can use the whole fruit, skin and pith and everything "), _c('a', {
    attrs: {
      "href": "#/xhtml/086part06chapter09#part6ch9"
    }
  }, [_vm._v("(such as in the chermoula on page 211)")]), _vm._v(", as well as the brine they’re packed in "), _c('a', {
    attrs: {
      "href": "#/xhtml/036part02chapter14#part2ch14"
    }
  }, [_vm._v("(like in the dressing for the zucchini salad on page 91)")]), _vm._v(". You can sometimes find them in the ethnic aisle of your grocery store, in most speciality and cheese stores (I think cheese people like the way they look on their shelves?), and also online. You can use a fresh lemon (or lemon juice) in its place and add a little extra bit of salt to compensate, too.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg23lev5"
    }
  }), _c('span', {
    staticClass: "font"
  }, [_c('strong', [_vm._v("Tahini")])]), _vm._v(", a thick paste made from ground sesame seeds, is a great way to get a nutty depth of flavor in dressings "), _c('a', {
    attrs: {
      "href": "#/xhtml/033part02chapter11#part2ch11"
    }
  }, [_vm._v("(such as the one for the carrot salad on page 84)")]), _vm._v(" and in dips "), _c('a', {
    attrs: {
      "href": "#/xhtml/051part03chapter13#part3ch13"
    }
  }, [_vm._v("(like the eggplant one on page 122)")]), _vm._v(". It’s widely available in grocery stores, often near the peanut butter (which it’s not that dissimilar to) and also online. If you can’t find it or don’t feel like buying it, feel free to use an equal amount of toasted sesame seeds in its place (you can even bash them using a mortar and pestle) or a bit of toasted sesame oil. Neither of these will give you the same texture, but you will get the right flavor.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7a4139","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/010-unusual.vue
// module id = 84
// module chunks = 0